import type { InitOptions } from 'i18next';
import i18n from 'i18next';
import type { HttpBackendOptions } from 'i18next-http-backend';
import HttpApi from 'i18next-http-backend';

import { UEFA_BASE_URL } from 'utils/uefaBaseUrl';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

const supportedLngs = ['en', 'de', 'fr', 'es', 'it', 'pt', 'ru'];

const html = document.querySelector('html');
let language = html!.getAttribute('lang') || 'en';
const hostLang = location.host.split('.')?.at(0);
if (supportedLngs.includes(hostLang)) {
  language = hostLang;
}

html!.setAttribute('lang', language);
html!.setAttribute('data-lang', language);

const ns = ['387075'];

const options: InitOptions<HttpBackendOptions> = {
  returnNull: false,
  supportedLngs,
  lng: language,
  fallbackLng: 'en',
  load: 'languageOnly',
  ns,
  defaultNS: ns[0],
  backend: {
    loadPath: `${UEFA_BASE_URL}/api/v1/vocabulary/{{ns}}/{{lng}}`,
    crossDomain: true,
    parse: (data, languages) => {
      const lng = Array.isArray(languages) ? languages[0] : languages;
      return JSON.parse(data)[lng ?? 'en']?.translation;
    },
  },
  interpolation: {
    escapeValue: false,
  },
  debug: import.meta.env.MODE === 'development',
};

i18n.use(HttpApi).init(options);

export default i18n;
